<mat-icon
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  [matBadge]="unreadCount"
  [matBadgeHidden]="unreadCount === 0"
  matBadgeColor="warn"
  matBadgeSize="large"
  matBadgePosition="above after"
  [matBadgeOverlap]="true"
  class="notif-icon"
  color="primary"
  svgIcon="mat:notifications_active">
</mat-icon>
